import React, { useEffect, useState } from "react";
import HeadlineFull from "../gd/HeadlineFull";
import ContactAgents from "../../components/shared/ContactAgents";
import HomeLink from "../../widgets/HomeLink";
import { Col, Form, notification, Select } from "antd";
import B2C2BApi from "../../api-services/b2c2b-api.service";
import { useSearchParams } from "react-router-dom";

const AGENT_DEPARTMENTS: string[] = ["Series", "Flight", "Visa"];
const DEFAULT_COUNTRY = "Singapore";
const COUNTRY_QUERY_PARAM = "country";

const bannerPath = '/iceholidays-assets/images/desktop_gdta_fair.png';
const mobileBannerPath = '/iceholidays-assets/images/mobile_gdta_fair.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Contact Agents' }
] 

interface FairOption {
  code: string;
}

const ContactAgentsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [fairs, setFairs] = useState<FairOption[]>([]);
  const [country, setCountry] = useState(searchParams.get(COUNTRY_QUERY_PARAM) || DEFAULT_COUNTRY);

  useEffect(() => {
    const nextCountry = searchParams.get(COUNTRY_QUERY_PARAM) || DEFAULT_COUNTRY;

    setCountry((currentCountry) => currentCountry === nextCountry ? currentCountry : nextCountry);
  }, [searchParams]);

  useEffect(() => {
    B2C2BApi.getFairs().then((fairsData) => {
      setFairs(fairsData);
    }).catch(() => {
      notification.error({ message: 'An error occured while loading fairs.'});
    });
  }, []);

  const handleCountryChange = (value: string) => {
    setCountry(value);
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set(COUNTRY_QUERY_PARAM, value);
    setSearchParams(nextSearchParams);
  };

  return (
    <div id="contact-agents-page" className="more-page">
      <HeadlineFull showSearch={false} mobileImage={mobileBannerPath} bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="Contact Agents"/>

      <ContactAgents 
        type={AGENT_DEPARTMENTS}
        initialValues={{ country }}
        locationFilterType={country === 'Singapore' ? 'zone' : 'state-city'}
        additionalFilters={
          <>
            <Col span={24}>
              <Form.Item label="Select Country" name="country" initialValue={country}>
                <Select
                  options={[
                    { label: 'Singapore', value: 'Singapore' },
                    { label: 'Indonesia', value: 'Indonesia' }
                  ]}
                  onChange={handleCountryChange}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Select Fair" name="fair">
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Please select"
                  options={fairs.map(({code}) => ({label: code, value: code}))}
                />
              </Form.Item>
            </Col>
          </>
        }/>
    </div>
  )
}

export default ContactAgentsPage;